
import { Component, Vue } from 'vue-property-decorator';
import { SapCustomer2 } from '@/api';
import vClickOutside from 'v-click-outside';

Vue.use(vClickOutside);
@Component
export default class SapSwitcher extends Vue {
  active = false;

  get enabledSapCustomers(): SapCustomer2[] {
    return this.$store.state.profile?.profile?.enabledSapCustomers;
  }

  get sapCustomer(): SapCustomer2 {
    return this.$store.state.profile?.profile?.sapCustomer;
  }

  get getOtherOptions(): SapCustomer2[] {
    return this.enabledSapCustomers?.filter(
      (customer: any) => customer.CustomerNr !== this.sapCustomer.CustomerNr,
    );
  }

  async setActiveSAPID(id: string) {
    this.active = false;
    await this.$store.dispatch('profile/changeSapId', id);
  }
}
